import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { MeasurementMetadata, Data } from "../interfaces/Data";

interface Props {
  onAuthError?: () => void;
}

export default class DataApis extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.DATA_API}/api/Data/`;

  getDataByCaptureAndDataPointId = <T,>(captureId: number, dataPointId: number): Promise<Data<T>[]> => {
    const apiAddress = `${DataApis.BASE_URL}ByCaptureAndDataPointId/CaptureId/${captureId}/DataPointId/${dataPointId}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => {
      if (!data) {
        return [];
      }
      if (!Array.isArray(data)) {
        return [];
      }
      return data;
    });
  };

  async getDataByCapturesAndDataPointIds<T>(
    captureDataPointPairs: MeasurementMetadata[] | undefined,
  ): Promise<Data<T>[][]> {
    if (captureDataPointPairs == null || captureDataPointPairs.length === 0) {
      return [];
    }
    const getDataByCaptureAndDataPointIdPromises = captureDataPointPairs.map((captureDataPointPair) =>
      this.getDataByCaptureAndDataPointId<T>(captureDataPointPair.captureId, captureDataPointPair.dataPointId),
    );
    return await Promise.all(getDataByCaptureAndDataPointIdPromises);
  }
}
